import script from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTextarea.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__